import { createContext, useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate, useLocation } from "react-router-dom";

export const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);
  const [autorizado, setAutorizado] = useState(false);
  const [permissoes, setPermissoes] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const usersStorage = localStorage.getItem("login");
    const permissoes = localStorage.getItem("permissoes");
    console.debug("userStorage", usersStorage);

    sessionStorage.removeItem("produtos");

    console.log(token);

    if (usersStorage) {
      console.log("logando");

      setAuthenticated(true);
      setPermissoes(JSON.parse(permissoes));
    }

    const dsNome = localStorage.getItem("nomeUsuario");
    if (!dsNome) {
      signout();
    }

    setLoading(false);
  }, []);

  const signin = async (email, password) => {
    try {
      const response = await axios.post("/emporio-api/auth/login", {
        email,
        password,
      });

      console.debug(response);

      if (response.data.status === 204) {
        return "Usuário não cadastrado";
      } else if (response.data.status === 200) {
        const token = response.data.token;
        localStorage.setItem("nomeUsuario", response.data.dsNome);
        localStorage.setItem("login", email);
        localStorage.setItem("token", JSON.stringify(token));
        localStorage.setItem(
          "permissoes",
          JSON.stringify(response.data.permissoes),
        );
        setAuthenticated(true);
        setPermissoes(response.data.permissoes);

        console.debug("permissoes", response.data.permissoes);

        console.log("sucesso");
        return;
      } else {
        return "Resultado inesperado";
      }
    } catch (error) {
      console.log(error);
      return "Erro na comunicação com o servidor";
    }
  };

  const signup = (email, password) => {
    const usersStorage = JSON.parse(localStorage.getItem("users_bd"));

    const hasUser = usersStorage?.filter((user) => user.email === email);

    if (hasUser?.length) {
      return "Já existe uma conta com esse E-mail";
    }

    let newUser;

    if (usersStorage) {
      newUser = [...usersStorage, { email, password }];
    } else {
      newUser = [{ email, password }];
    }

    localStorage.setItem("users_bd", JSON.stringify(newUser));

    return;
  };

  const signout = () => {
    localStorage.removeItem("login");
    localStorage.removeItem("nomeUsuario");
    localStorage.removeItem("token");
    localStorage.removeItem("permissoes");
    sessionStorage.removeItem("produtos");

    setAuthenticated(false);
    setPermissoes([]);
  };

  return (
    <AuthContext.Provider
      value={{ authenticated, permissoes, signin, signup, signout, loading }}
    >
      {children}
    </AuthContext.Provider>
  );
};
